import { MicroSiteMediaSubPage } from 'components/MicroSite/MediaSubPage';

const ScreenMicroSiteMediaSubPage = () => <MicroSiteMediaSubPage />;

export default ScreenMicroSiteMediaSubPage;
